<template>
  <LinkBoosterList class="mb-72" :links>
    <template #title>
      <p class="heading-3" data-selector="tags-lp-title">
        {{ i18n(translations.soundAndFurious) }}
        {{ i18n(translations.popularSearches) }}
      </p>
    </template>
  </LinkBoosterList>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import type { LinkBooster } from '~/api/internal-links/types'
import LinkBoosterList from '~/scopes/seo/components/LinkBoosterList.vue'

import translations from './ProductTags.translations'

const i18n = useI18n()

const { links } = defineProps<{ links: LinkBooster[] }>()
</script>
